import React from 'react';
import AnnouncementBar from '../components/AnnouncementBar';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import HomepageLexi from '../components/HomepageLexi';
import ContentDepthStrip from '../components/ContentDepthStrip';
import RealityCheck from '../components/RealityCheck';
import PathStories from '../components/PathStories';
import CommunitySection from '../components/community/CommunitySection';
import VisitorsTillNow from '../components/VisitorsTillNow';
import ClarityImpactStrip from '../components/ClarityImpactStrip';
import PathPillStrip from '../components/PathPillStrip';
import FeedbackBand from '../components/FeedbackBand';
import HomeFAQSection from '../components/HomeFAQSection';
import Footer from '../components/Footer';
import ScrollProgress from '../components/ScrollProgress';
import SEOHead from '../components/SEOHead';

const HomePage = () => {
  const homeStructured = {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: 'LearnixTa',
    url: 'https://learnixta.com',
    description: 'Honest Career Clarity',
    sameAs: ['https://www.instagram.com/learnixta_/'],
    address: { '@type': 'PostalAddress', addressCountry: 'IN' },
  };
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Honest Career Clarity"
        description="Honest Career Clarity"
        path="/"
        structuredData={homeStructured}
      />
      <ScrollProgress />

      {/* S0 */}
      <AnnouncementBar />
      {/* S1 */}
      <Navbar />

      {/* S2 — focused single question */}
      <Hero />

      {/* Lexi above-the-fold — anchor for direct-question students */}
      <HomepageLexi />

      {/* NS1 — scrolling depth stats marquee */}
      <ContentDepthStrip />

      {/* S4 — hard truth, stat-driven */}
      <RealityCheck />

      {/* Measured clarity impact — aggregate before → after */}
      <ClarityImpactStrip />

      {/* Honest all-time unique visitor counter — directly above reviews */}
      <VisitorsTillNow />

      {/* S8 — transformation arcs (replaces ProofTrust) */}
      <PathStories />

      {/* Learnixta Community — daily Q&A, directly below reviews */}

      {/* Dark pill strip — catch undecided visitors right after the trust peak */}
      <PathPillStrip />

      {/* Honest feedback band — for the most engaged visitors */}
      <FeedbackBand />

      {/* S12 — Frequently Asked Questions */}
      <HomeFAQSection />

      {/* S13 */}
      <Footer />

      {/* Floating mentor button replaced by global Lexi launcher in App.js */}
    </div>
  );
};

export default HomePage;
